// Transparent → frosted-glass on scroll
(function () {
  var THRESHOLD = 40;
  var wrapper = null;
  // In the Shopify admin editor, skip direct style overrides so the
  // editor's section-selection overlays are not broken.
  var inEditor = window.Shopify && window.Shopify.designMode;

  function updateHeader() {
    if (!wrapper) return;
    var scrolled = window.scrollY > THRESHOLD;
    wrapper.classList.toggle('is-scrolled', scrolled);
  }

  function init() {
    wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
